// Datos de pago por transferencia (alternativa cuando el pago con tarjeta no se completa).
// Beneficiario mostrado como "ClinPed".
export const TRANSFER = {
  bank: "BBVA",
  holder: "ClinPed",
  clabe: "012180015318669340",
  account: "1531866934",
  phone: "5533285931",
  supportEmail: "soporteclinped@expedienteelectronicoclinped.com",
};

export const PLAN_LABEL = { base: "Plan Básico", dental: "Plan Odontológico", pro: "Plan Pro" };
export const PLAN_AMOUNT = { base: "150", dental: "170", pro: "400" };

// Abre el modal global de transferencia (lo escucha <TransferModal/> montado en App).
export function openTransfer(plan = "pro") {
  window.dispatchEvent(new CustomEvent("clinped-open-transfer", { detail: { plan } }));
}
